(function () {
  'use strict';
  var pending = new WeakSet();
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!form.matches('[data-rv-form]')) return;
    var quantity = form.querySelector('[data-rv-qty-input]');
    if (quantity && quantity.value.trim() === '') quantity.value = '1';
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    event.preventDefault();
    if (pending.has(form)) return;
    pending.add(form);
    var button = form.querySelector('[data-rv-atc]');
    var status = form.querySelector('[data-rv-cart-status]');
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-rv-cart-status', '');
      status.setAttribute('role', 'alert');
      button.closest('.rv-atc').after(status);
    }
    status.textContent = '';
    status.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    drawer.setActiveElement(event.submitter || button);
    var added = false;
    var root = window.Shopify.routes.root;
    try {
      var body = new FormData(form);
      var sections = drawer.getSectionsToRender().map(function (section) { return section.id; });
      body.set('sections', sections.join(','));
      body.set('sections_url', window.location.pathname);
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST', body: body, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      var result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'This item could not be added. Please try again.');
      added = true;
      if (!result.sections || sections.some(function (id) { return !result.sections[id]; })) {
        // A successful add must never be repeated merely because rendering failed.
        var refresh = await fetch(root + '?sections=' + sections.join(','));
        if (!refresh.ok) throw new Error('Cart refresh failed');
        result.sections = await refresh.json();
        if (sections.some(function (id) { return !result.sections[id]; })) throw new Error('Cart refresh failed');
      }
      drawer.classList.remove('is-empty');
      drawer.renderContents(result);
    } catch (error) {
      status.hidden = false;
      status.textContent = added
        ? 'Your item was added, but the cart preview could not load. '
        : (error.message === 'Failed to fetch' ? 'We could not confirm your cart update. Check your cart before trying again. ' : error.message + ' ');
      var link = document.createElement('a');
      link.href = root + 'cart';
      link.textContent = 'View cart';
      status.appendChild(link);
    } finally {
      pending.delete(form);
      var selected = form.querySelector('[data-rv-variant]:checked');
      button.disabled = !!(selected && selected.dataset.available === 'false');
      button.removeAttribute('aria-busy');
    }
  });
})();
